import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { addresses: Array }
  static targets = [
    "fullName", "companyName", "email", "address", "city", "state", "postalCode",
    "country", "countryCode", "telephone", "companyToggle", "emailToggle"
  ]

  connect() {
    // Auto-fill from the pre-selected saved address on mount
    const select = this.element.querySelector('select[data-action*="address-selector#fill"]')
    if (select && select.value) {
      this.fill({ target: select })
    }
  }

  fill(event) {
    const selectedId = event.target.value
    if (!selectedId) return

    const addr = this.addressesValue.find(a => String(a.id) === String(selectedId))
    if (!addr) return

    this._set(this.fullNameTarget, addr.full_name)
    this._set(this.addressTarget, addr.address)
    this._set(this.cityTarget, addr.city)
    this._set(this.stateTarget, addr.state)
    this._set(this.postalCodeTarget, addr.postal_code)
    this._set(this.countryTarget, addr.country)
    this._set(this.countryCodeTarget, addr.country_code)
    this._set(this.telephoneTarget, addr.telephone)

    if (this.hasCompanyNameTarget) {
      this._set(this.companyNameTarget, addr.company_name)
      if (this.hasCompanyToggleTarget) {
        if (addr.company_name) { this.companyToggleTarget.classList.remove('hidden') }
        else { this.companyToggleTarget.classList.add('hidden') }
      }
    }

    if (this.hasEmailTarget) {
      this._set(this.emailTarget, addr.email)
      if (this.hasEmailToggleTarget) {
        if (addr.email) { this.emailToggleTarget.classList.remove('hidden') }
        else { this.emailToggleTarget.classList.add('hidden') }
      }
    }
  }

  toggleCompany(event) {
    event.preventDefault()
    if (!this.hasCompanyToggleTarget) return
    const container = this.companyToggleTarget
    if (container.classList.contains('hidden')) {
      container.classList.remove('hidden')
    } else {
      container.classList.add('hidden')
      if (this.hasCompanyNameTarget) this.companyNameTarget.value = ''
    }
  }

  toggleEmail(event) {
    event.preventDefault()
    if (!this.hasEmailToggleTarget) return
    const container = this.emailToggleTarget
    if (container.classList.contains('hidden')) {
      container.classList.remove('hidden')
    } else {
      container.classList.add('hidden')
      if (this.hasEmailTarget) this.emailTarget.value = ''
    }
  }

  _set(el, value) {
    el.value = value || ""
    el.dispatchEvent(new Event("input", { bubbles: true }))
    if (el.tagName === "SELECT") {
      el.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
